import React, { useEffect, useState } from 'react';
import firebase from 'firebase'
import Context from './index';
import { getSingleDocument } from '../../firebase/utils';

const AdminProvider = (props) => {
  const [user, setUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [location, setLocation] = useState(null)
  const [adminRoles, setAdminRoles] = useState();

  const fetchAdminDetails = async () => {
    firebase.auth().onAuthStateChanged(async function (user) {
      if (user) {
        const userDoc = await getSingleDocument(user?.email?.trim())
        setUser(userDoc)
        setIsAuthenticated(true)
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    })
  }

  useEffect(() => {
    fetchAdminDetails()
  }, [])

  return (
    <Context.Provider
      value={{
        ...props,
        user,
        isAuthenticated,
        setUser,
        isLoading,
        location,
        setLocation,
        adminRoles,
        setAdminRoles
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default AdminProvider;
